import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetosindudargcabservice() {



    const cardData = {

keyword: "Pune to Sindhudurg Cab Service",

headingDescription:
    "Rising Cab Service offers safe, comfortable, and reliable Pune to Sindhudurg Cab Service for families, tourists, and coastal travelers. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles with experienced chauffeurs for a smooth long-distance journey from Pune to the Konkan region. Our service includes doorstep pickup, flexible one-way and round-trip options, 24/7 support, and transparent pricing, ensuring a relaxed and scenic travel experience across the Western Ghats to Sindhudurg.",

topPlaces: [
    {
        title: "Sindhudurg Fort",
        description:
            "Sindhudurg Fort is a historic sea fort built by Chhatrapati Shivaji Maharaj on an island off the Malvan coast. It is one of the most iconic forts in Maharashtra, known for its massive stone walls, sea views, and rich Maratha history. The boat ride to the fort adds a unique coastal adventure experience for visitors."
    },
    {
        title: "Tarkarli Beach",
        description:
            "Tarkarli Beach is famous for its crystal-clear waters, white sandy shoreline, and adventure water sports like scuba diving and snorkeling. It is one of the cleanest beaches in Maharashtra and a top attraction for marine tourism in the Sindhudurg region."
    },
    {
        title: "Malvan Beach",
        description:
            "Malvan Beach is a vibrant coastal destination known for its seafood, water sports, and scenic sunsets. It serves as a gateway to Sindhudurg Fort and offers a mix of relaxation and adventure for tourists exploring Konkan."
    },
    {
        title: "Devbagh Beach",
        description:
            "Devbagh Beach is a serene and less crowded beach located near the Karli River backwaters. It is ideal for peaceful relaxation, photography, and enjoying the natural beauty of the Arabian Sea and surrounding lagoons."
    },
    {
        title: "Chivla Beach",
        description:
            "Chivla Beach is a small, clean, and calm beach in Malvan known for its peaceful environment and beautiful sunset views. It is perfect for travelers seeking a quiet coastal experience away from crowds."
    },
    {
        title: "Rock Garden Malvan",
        description:
            "Rock Garden is a scenic coastal park in Malvan offering rocky shoreline views, sunset points, and seating areas. It is a popular spot for evening relaxation and photography along the Sindhudurg coast."
    },
    {
        title: "Vengurla Beaches",
        description:
            "Vengurla is known for its untouched and clean beaches surrounded by hills and coconut trees. Beaches like Sagareshwar and Vengurla Beach are ideal for peaceful coastal drives and nature exploration."
    },
    {
        title: "Amboli Hill Station",
        description:
            "Amboli is a lush green hill station near Sindhudurg famous for waterfalls, misty valleys, and biodiversity. It is especially beautiful during the monsoon and offers a refreshing break from coastal heat."
    },
    {
        title: "Devgad Fort & Lighthouse",
        description:
            "Devgad Fort is a historic coastal fort offering panoramic sea views and nearby lighthouse attractions. The region is also famous for Alphonso mangoes and scenic Konkan landscapes."
    },
    {
        title: "Karli Backwaters",
        description:
            "Karli Backwaters offer a peaceful boating and nature experience surrounded by mangroves and coastal scenery. It is a relaxing attraction for travelers exploring the Sindhudurg coastal belt."
    }
],



services: [
  {
    name: "Pune to Sindhudurg Cab",
    description: "Rising Cab Service offers premium Pune to Sindhudurg Cab service for a safe, scenic, and comfortable Konkan journey. Ideal for families, groups, and beach lovers, our service includes well-maintained AC vehicles, experienced long-route drivers, doorstep pickup from Pune, flexible travel timing, and 24x7 booking support. Enjoy a smooth highway drive through Maharashtra’s coastal routes with complete comfort, transparent pricing, and a stress-free travel experience to Sindhudurg."
  },
  {
    name: "Pune to Sindhudurg Taxi",
    description: "Book Pune to Sindhudurg Taxi with Rising Cab Service for reliable and comfortable long-distance travel to the beautiful Konkan region. We provide clean sanitized cars, professional chauffeurs, and safe driving through highways and coastal roads. Perfect for beach vacations, fort visits, and family trips with flexible pickup and drop options."
  },
  {
    name: "Cab from Pune to Sindhudurg",
    description: "Hire Cab from Pune to Sindhudurg for convenient door-to-door travel covering scenic Konkan highways. Choose from sedan, SUV, and Innova Crysta options depending on your group size. Our experienced drivers ensure safe travel with planned stops, smooth rides, and complete comfort throughout the journey."
  },
  {
    name: "Taxi from Pune to Sindhudurg",
    description: "Taxi from Pune to Sindhudurg service ensures punctual pickup, professional drivers, and safe long-distance travel to coastal Maharashtra. Perfect for weekend trips, beach holidays, and family tours, our taxis provide AC comfort, affordable pricing, and reliable service."
  },
  {
    name: "Pune to Sindhudurg Cab Service",
    description: "Our Pune to Sindhudurg Cab Service provides complete travel solutions including pickup, drop, sightseeing flexibility, and return options. We ensure safe driving, comfortable seating, and 24x7 support for a hassle-free Konkan travel experience."
  },
  {
    name: "Pune to Sindhudurg Taxi Fare",
    description: "Get transparent Pune to Sindhudurg Taxi Fare with clear, affordable pricing based on vehicle type and trip plan. We offer budget-friendly and premium cab options with no hidden charges, ensuring value-for-money travel for long Konkan routes."
  },
  {
    name: "Pune to Sindhudurg One Way Cab",
    description: "Book Pune to Sindhudurg One Way Cab for economical drop-only travel to Konkan destinations. Ideal for solo travelers and families, this service includes AC vehicles, professional drivers, and smooth highway travel at affordable rates."
  },
  {
    name: "Pune to Sindhudurg Round Trip Taxi",
    description: "Pune to Sindhudurg Round Trip Taxi service is perfect for Konkan vacations and beach holidays. It includes flexible return scheduling, waiting time, comfortable vehicles, and experienced drivers for a complete round-trip travel experience."
  },
  {
    name: "Pune to Sindhudurg Cab Booking",
    description: "Easy Pune to Sindhudurg Cab Booking system for instant reservations with multiple vehicle choices including Sedan, SUV, Innova Crysta, and Tempo Traveller. Get quick confirmation, transparent pricing, and 24x7 customer support."
  },
  {
    name: "Cheap Pune to Sindhudurg Cab",
    description: "Affordable Cheap Pune to Sindhudurg Cab service for budget travelers who want economical yet safe Konkan travel. We provide low fares, clean vehicles, and professional drivers without compromising comfort or safety."
  },
  {
    name: "Best Pune to Sindhudurg Taxi",
    description: "Choose Best Pune to Sindhudurg Taxi service for premium travel experience with top-rated drivers, comfortable vehicles, and smooth highway driving through scenic Konkan routes."
  },
  {
    name: "Sedan Pune to Sindhudurg Cab",
    description: "Sedan Pune to Sindhudurg Cab service is ideal for solo travelers, couples, and small families seeking budget-friendly and comfortable long-distance travel."
  },
  {
    name: "SUV Pune to Sindhudurg Taxi",
    description: "Book SUV Pune to Sindhudurg Taxi for group travel requiring extra space and comfort. Our SUVs are perfect for Konkan roads, offering smooth rides and strong performance."
  },
  {
    name: "Innova Pune to Sindhudurg Cab",
    description: "Premium Innova Pune to Sindhudurg Cab service for families and groups seeking luxury, comfort, and spacious seating for long coastal journeys."
  },
  {
    name: "Konkan Cab Pune Sindhudurg",
    description: "Konkan Cab Pune Sindhudurg service is specially designed for exploring coastal Maharashtra with scenic routes, beach stops, and comfortable long-distance travel."
  },
  {
    name: "Sindhudurg Cab from Pune",
    description: "Sindhudurg Cab from Pune service offers direct door-to-door travel to Sindhudurg with safe driving, flexible schedules, and professional chauffeurs."
  },
  {
    name: "Pune to Sindhudurg Konkan Tour Cab",
    description: "Pune to Sindhudurg Konkan Tour Cab offers complete travel packages covering beaches, forts, and sightseeing spots across Konkan with flexible itineraries."
  },
  {
    name: "Pune to Sindhudurg Beach Cab",
    description: "Pune to Sindhudurg Beach Cab service ensures a smooth coastal journey to popular beaches with comfortable AC vehicles and experienced drivers."
  },
  {
    name: "Pune to Sindhudurg Tourist Cab Service",
    description: "Pune to Sindhudurg Tourist Cab Service provides complete travel solutions for tourists exploring Konkan beaches, forts, and scenic destinations."
  },
  {
    name: "Pune to Sindhudurg Innova Taxi",
    description: "Premium Pune to Sindhudurg Innova Taxi service offers spacious seating, luxury comfort, and smooth travel for families and group trips."
  },
  {
    name: "Pune to Sindhudurg Tour Package",
    description: "Complete Pune to Sindhudurg Tour Package including pickup, sightseeing, beach visits, and return journey for a hassle-free Konkan vacation."
  },
  {
    name: "Pune to Sindhudurg Fort Cab",
    description: "Pune to Sindhudurg Fort Cab service provides safe and comfortable travel to historic Sindhudurg Fort with professional drivers and flexible stops."
  },
  {
    name: "Pune to Malvan Cab",
    description: "Pune to Malvan Cab service offers smooth travel to Malvan beaches with AC vehicles, experienced drivers, and affordable pricing."
  },
  {
    name: "Pune to Tarkarli Beach Cab",
    description: "Pune to Tarkarli Beach Cab service ensures a scenic coastal journey to one of the most beautiful beaches in Konkan with comfortable travel."
  },
  {
    name: "Pune to Konkan Tour Cab",
    description: "Pune to Konkan Tour Cab service offers complete travel packages covering multiple coastal destinations, beaches, and sightseeing points."
  },
  {
    name: "Pune to Malvan Taxi Service",
    description: "Pune to Malvan Taxi Service provides reliable and safe travel to Malvan with professional drivers and comfortable long-distance vehicles."
  },
  {
    name: "Pune to Tarkarli Cab Booking",
    description: "Easy Pune to Tarkarli Cab Booking system for instant reservations with multiple vehicle options and transparent pricing."
  },
  {
    name: "Pune to Sindhudurg Beach Tour",
    description: "Pune to Sindhudurg Beach Tour offers a complete coastal travel experience covering beaches, forts, and scenic Konkan routes."
  },
  {
    name: "Konkan Darshan Cab from Pune",
    description: "Konkan Darshan Cab from Pune provides a full sightseeing experience across Konkan with flexible travel plans and comfortable vehicles."
  },
  {
    name: "Pune to Sindhudurg Family Tour Package",
    description: "Pune to Sindhudurg Family Tour Package is designed for safe and enjoyable family travel with comfortable cars and customized Konkan itineraries."
  }
],

tableData: [
  ["Pune to Sindhudurg Cab", "Pune to Sindhudurg Taxi"],
  ["Cab from Pune to Sindhudurg", "Taxi from Pune to Sindhudurg"],
  ["Pune to Sindhudurg Cab Service", "Pune to Sindhudurg Taxi Fare"],
  ["Pune to Sindhudurg One Way Cab", "Pune to Sindhudurg Round Trip Taxi"],
  ["Pune to Sindhudurg Cab Booking", "Cheap Pune to Sindhudurg Cab"],
  ["Best Pune to Sindhudurg Taxi", "Sedan Pune to Sindhudurg Cab"],
  ["SUV Pune to Sindhudurg Taxi", "Innova Pune to Sindhudurg Cab"],
  ["Konkan Cab Pune Sindhudurg", "Sindhudurg Cab from Pune"],
  ["Pune to Sindhudurg Konkan Tour Cab", "Pune to Sindhudurg Beach Cab"],
  ["Pune to Sindhudurg Tour Package", "Pune to Sindhudurg Family Tour Package"]
],



whychoose: [
    {
        WhyChooseheading: "Comfortable Pune to Sindhudurg Cab Service",
        WhyChoosedescription: "Rising Cab Service provides reliable Pune to Sindhudurg cab transportation for families, tourists, beach lovers, history enthusiasts, and Konkan vacation travelers."
    },
    {
        WhyChooseheading: "Perfect for Konkan Tourism and Beach Holidays",
        WhyChoosedescription: "Sindhudurg is known for its pristine beaches, historic sea fort, water sports activities, coastal villages, and scenic Konkan landscapes."
    },
    {
        WhyChooseheading: "Customized One-Way and Round Trip Packages",
        WhyChoosedescription: "Customers can choose one-way travel, round-trip journeys, weekend vacations, multi-day tours, and personalized Konkan travel itineraries."
    },
    {
        WhyChooseheading: "Wide Range of Comfortable Vehicles",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to passenger requirements and group size."
    },
    {
        WhyChooseheading: "Explore Famous Sindhudurg Attractions",
        WhyChoosedescription: "Visit Sindhudurg Fort, Tarkarli Beach, Devbagh Beach, Malvan, Tsunami Island, Rock Garden, and other popular tourist destinations."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Doorstep pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and nearby locations."
    },
    {
        WhyChooseheading: "Safe Travel on Konkan Coastal Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with Konkan highways and coastal roads, ensuring a safe, smooth, and enjoyable journey."
    },
    {
        WhyChooseheading: "Ideal for Family Tours and Group Vacations",
        WhyChoosedescription: "Rising Cab Service caters to family holidays, honeymoon trips, corporate outings, beach vacations, and sightseeing tours across Sindhudurg."
    }
]
};

const faqData = [
    {
        question: "Why is Sindhudurg a popular tourist destination?",
        answer: "Sindhudurg is famous for Sindhudurg Fort, Tarkarli Beach, water sports, scuba diving, coastal beauty, and historical significance."
    },
    {
        question: "Can I book a one-way cab from Pune to Sindhudurg?",
        answer: "Yes, one-way cab services are available along with round-trip and customized Konkan tour packages."
    },
    {
        question: "Which attractions can be covered during a Sindhudurg trip?",
        answer: "Popular attractions include Sindhudurg Fort, Tarkarli Beach, Devbagh Beach, Tsunami Island, Malvan, Rock Garden, and nearby coastal destinations."
    },
    {
        question: "Which vehicle is suitable for a family trip to Sindhudurg?",
        answer: "Ertiga and Innova Crysta are among the most preferred options because they provide comfort, luggage space, and a smooth travel experience."
    },
    {
        question: "Do you provide Tempo Travellers for group tours?",
        answer: "Yes, Tempo Travellers and larger vehicles are available for family groups, corporate outings, and Konkan sightseeing tours."
    },
    {
        question: "Can Tarkarli and Malvan be included in the same package?",
        answer: "Yes, customized travel plans can include Tarkarli, Malvan, Devbagh, Kunkeshwar, and other nearby attractions."
    },
    {
        question: "Are beach holiday packages available for Sindhudurg?",
        answer: "Yes, customers can choose weekend beach vacations, multi-day Konkan tours, and customized holiday packages."
    },
    {
        question: "Can tourists enjoy water sports during the trip?",
        answer: "Yes, Tarkarli and Devbagh are famous for water sports activities including scuba diving, snorkeling, parasailing, and boating."
    },
    {
        question: "Are pickups available from Pune Airport and Railway Station?",
        answer: "Yes, pickups can be arranged from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "How can I book a Pune to Sindhudurg Cab Service?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Santosh Naik",
        feedback:
            "Our Sindhudurg and Tarkarli vacation was wonderfully planned. The cab was comfortable, the coastal journey was scenic, and the entire travel experience was excellent.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Reshma Sawant",
        feedback:
            "We explored Malvan, Devbagh, and Sindhudurg Fort with complete convenience. The vehicle was spacious, and the journey made our Konkan holiday truly memorable.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];









const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Sindhudurg Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-sindhudurg-cab.jpg",
"description": "Book Pune to Sindhudurg Cab Service with Rising Cab Service for safe and comfortable coastal and Konkan travel. Enjoy reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars for family and holiday trips.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-sindhudurg-cab"
}
};










    return (
        <div>

<Helmet>
  <title>Pune to Sindhudurg Cab Service | Konkan Travel Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Sindhudurg Cab Service for safe and comfortable Konkan travel. Get affordable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars for beach and family trips."
/>

<meta
 name="keywords"
 content="pune to sindhudurg cab, pune to sindhudurg taxi, cab from pune to sindhudurg, taxi from pune to sindhudurg, pune to sindhudurg cab service, pune to sindhudurg taxi fare, pune to sindhudurg one way cab, pune to sindhudurg round trip taxi, pune to sindhudurg cab booking, cheap pune to sindhudurg cab, best pune to sindhudurg taxi, sedan pune to sindhudurg cab, suv pune to sindhudurg taxi"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>

            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/105.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetosindudargcabservice;